<script>
// import { POINT_MARKER_ICON_CONFIG } from '@/consts/mapSettings';
// import Vue from 'vue';
import EventBus from '@/event-bus';

export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    marker: {
      type: Object,
      required: true,
    },
    defaultShow: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    const { Marker } = this.google.maps;
    // console.log(this.marker);
    // eslint-disable-next-line
    const p1 = 'm12 0c-4.4183 2.3685e-15 -8 3.5817-8 8 0 1.421 0.3816 2.75 1.0312 3.906 0.1079 0.192 0.221 0.381 0.3438 0.563l6.625 11.531 6.625-11.531c0.102-0.151 0.19-0.311 0.281-0.469l0.063-0.094c0.649-1.156 1.031-2.485 1.031-3.906 0-4.4183-3.582-8-8-8zm0 4c2.209 0 4 1.7909 4 4 0 2.209-1.791 4-4 4-2.2091 0-4-1.791-4-4 0-2.2091 1.7909-4 4-4z';
    // eslint-disable-next-line
    const p2 = 'm12 3c-2.7614 0-5 2.2386-5 5 0 2.761 2.2386 5 5 5 2.761 0 5-2.239 5-5 0-2.7614-2.239-5-5-5zm0 2c1.657 0 3 1.3431 3 3s-1.343 3-3 3-3-1.3431-3-3 1.343-3 3-3z';
    const p1Colors = [
      '#000000',
      '#F24C3B',
      '#FFDD07',
      '#FFFFFF',
    ];
    const p2Colors = [
      '#000000',
      '#C0392B',
      '#FED200',
      '#D1D1D1',
    ];
    const m = new Marker({
      position: this.marker.position,
      title: this.marker.title,
      marker: this.marker,
      map: this.map,
      shape: 'marker',
      // label: this.marker.label,
      icon: {
        path: p1,
        fillColor: p1Colors[this.marker.priority],
        fillOpacity: 1,
        scale: 1.75,
        strokeOpacity: 0.5,
        strokeWeight: 1.5,
        anchor: { x: 12, y: 24 },
      },
    });
    m.setVisible(this.defaultShow);
    m.addListener('click', () => {
      // console.log('MARKER CLICKED!');
      EventBus.$emit('modal-open', this.marker.id);
    });

    this.$markers.push(m);
    this.$markerIndex[this.marker.id].push(m);

    const m2 = new Marker({
      position: this.marker.position,
      title: this.marker.title,
      marker: this.marker,
      map: this.map,
      shape: 'ring',
      // label: this.marker.label,
      icon: {
        path: p2,
        fillColor: p2Colors[this.marker.priority],
        // fillColor: '#c0392b',
        fillOpacity: 1,
        scale: 1.75,
        strokeOpacity: 0.5,
        strokeWeight: 1.5,
        anchor: { x: 12, y: 24 },
      },
    });
    m2.setVisible(this.defaultShow);
    m2.addListener('click', () => {
      // console.log('MARKER CLICKED!');
      EventBus.$emit('modal-open', this.marker.id);
    });
    this.$markers.push(m2);
    this.$markerIndex[this.marker.id].push(m2);
  },
  beforeDestroy() {
    this.$markers.pop();
    this.$markerIndex[this.marker.id].pop();
    this.$markers.pop();
    this.$markerIndex[this.marker.id].pop();
  },

  methods: {
    emitMethod() {
      EventBus.$emit('EVENT_NAME', 'some stuff');
    },
  },
  // eslint-disable-next-line
  render() {},
};
</script>
